import axios from 'axios';
import { API_BASE_URL } from '@/config/api';
import { toast } from 'sonner';

// 创建 axios 实例
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 请求拦截器 - 添加 Token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器 - 处理 Token 过期
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token 无效或过期
      const errorMsg = error.response?.data?.message || '';
      if (errorMsg.includes('Token') || errorMsg.includes('过期') || errorMsg.includes('无效')) {
        // 检查当前页面是否已经是登录页
        if (window.location.pathname !== '/login') {
          toast.error('登录已过期，请重新登录');
          // 清除 token 并跳转到登录页
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          // 使用 setTimeout 确保 token 已清除
          setTimeout(() => {
            window.location.href = '/login';
          }, 100);
        }
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
